var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"grey lighten-3"},[_c('v-container',[_c('v-sheet',{attrs:{"min-height":"calc(100vh - 160px)","min-width":"100%","rounded":"lg"}},[_c('router-view'),_c('div',{staticClass:"pb-2 d-flex border-top"},[_c('v-spacer')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }